import "./TextHeader.css"

export default function TextHeader({title}) {
    return (
        <div className={'text-header'}>
            <h2>{title}</h2>
        </div>
    )
}